module.exports = __webpack_public_path__ + "img/icon_certificacion_child_count_hover.497bca59.svg";